import { combineReducers } from 'redux';
import { createFetchReducer, FetchingReducerState } from 'store/setLocalStore';
import {
  DETAIL_DOWNLOAD,
  GET_PAYMENT_DETAIL,
  PAYMENT_DOWNLOAD,
  GET_ENCOUNTER_DETAIL
} from './actions';
import { EncounterDetail, PaymentDetailSummary } from './types';

export type DetailDownloadState = FetchingReducerState<any>;
export type PaymentDownloadState = FetchingReducerState<any>;
export type PaymentDetailState = FetchingReducerState<PaymentDetailSummary>;
export type EncounterDetailState = FetchingReducerState<EncounterDetail>;

export interface BillingState {
  detailsDownload: DetailDownloadState;
  paymentsDownload: PaymentDownloadState;
}
export interface PaymentState {
  paymentDetailState: PaymentDetailState;
}
export interface EncounterState {
  encounterDetail: EncounterDetailState;
}

const encounterDetailReducer = createFetchReducer<EncounterDetail>(GET_ENCOUNTER_DETAIL);
const getPaymentDetailReducer = createFetchReducer<PaymentDetailSummary>(GET_PAYMENT_DETAIL);

export default combineReducers({
  detailsDownload: createFetchReducer(DETAIL_DOWNLOAD),
  paymentsDownload: createFetchReducer(PAYMENT_DOWNLOAD),
  paymentDetail: getPaymentDetailReducer,
  encounterDetail: encounterDetailReducer
});
